import HomeIcon from '@mui/icons-material/Home';
import MapIcon from '@mui/icons-material/Map';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import HistoryIcon from '@mui/icons-material/History';
import MenuBookIcon from '@mui/icons-material/MenuBook';

export function navigationItems(customerKey, showCaregiverPages) {
    const customerPath = `/caregivers/${encodeURIComponent(customerKey)}`;
    return [
        { id: 'dashboard', label: 'Dashboard', path: '/dashboard', Icon: HomeIcon },
        { id: 'map', label: 'Map', path: '/map', Icon: MapIcon, disabled: !customerKey },
        { id: 'customerInformation', label: 'Customer', moreOnly: true, path: '/customer-information', Icon: ContactPageIcon, disabled: !customerKey },
        ...(showCaregiverPages ? [
            { id: 'caregivers', label: 'Caregivers', path: customerPath, Icon: PeopleAltIcon, disabled: !customerKey },
            { id: 'history', label: 'History', moreOnly: true, path: `${customerPath}/changes`, Icon: HistoryIcon, disabled: !customerKey }
        ] : []),
        { id: 'resources', label: 'Resources', moreOnly: true, path: '/resources', Icon: MenuBookIcon }
    ];
}

export function activeNavigationItem(items, pathname) {
    // Prefer specific child routes over the caregiver-list route.
    return [...items].reverse().find(item => !item.disabled &&
        (pathname === item.path || (item.id === 'caregivers' && pathname.startsWith(`${item.path}/`))));
}

export function visibleNavigationCount(widths, moreWidth, availableWidth, reserveMore = false) {
    if (!reserveMore && widths.reduce((total, width) => total + width, 0) <= availableWidth) return widths.length;
    let used = moreWidth;
    let count = 0;
    while (count < widths.length && used + widths[count] <= availableWidth) used += widths[count++];
    return count;
}
